import { setAsVariantFlowAction as setAsVariantFlowOperation } from 'editor/src/store/variants/slice';

export default setAsVariantFlowOperation;
